module.exports = "pegasus/assets/blocks/column-9-theme4.png";